export default __webpack_public_path__ + "static/media/mobile_applications_xl.1be11384.jpg";